import { iconName } from "../designSystem/icons/Icons";

export const articleIconHelper = {
    getArticleListIcon:(listName:string): iconName =>
    {
        if(listName === 'Farligt gods')
            return 'warning';
        else if(listName === 'Miljø')
            return 'eco';
        else if(listName === 'Andre lovkrav')
            return 'policy'
        else if(listName === 'Brand')
            return 'fire_truck'
        else if(listName === 'Arbejdsmiljø')
            return 'interface_user_team';
        else if(listName === 'Energi')
            return 'energy'
        else if(listName === 'ESG')
            return 'nature_people';
        else
            return 'help';
    }

}